import { render } from "./FamilyThomasAdolphus.vue?vue&type=template&id=a9fa7ba2&scoped=true"
import script from "./FamilyThomasAdolphus.vue?vue&type=script&lang=js"
export * from "./FamilyThomasAdolphus.vue?vue&type=script&lang=js"

import "./FamilyThomasAdolphus.vue?vue&type=style&index=0&id=a9fa7ba2&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-a9fa7ba2"

export default script